import { render } from "./AnimatedText.vue?vue&type=template&id=798362d2&scoped=true"
import script from "./AnimatedText.vue?vue&type=script&lang=js"
export * from "./AnimatedText.vue?vue&type=script&lang=js"

import "./AnimatedText.vue?vue&type=style&index=0&id=798362d2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-798362d2"]])

export default __exports__